import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SOMMELIER_AVATAR = "https://customer-assets.emergentagent.com/job_wine-sommelier-2/artifacts/vu5iglcz_att.ynPmhaFhSeLs5blyB0W6yY3b31D9r_dMDQ9FnJVxofo.jpeg";

const QRCard = ({ restaurant = 'notl' }) => {
  const chatUrl = `${BACKEND_URL}/${restaurant}`;

  return (
    <div className="min-h-screen bg-gray-200 flex items-center justify-center p-8 print:bg-white print:p-0 print:min-h-0">
      {/* Print hint */}
      <div className="fixed top-4 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur border border-gray-200 rounded-full px-5 py-2 text-sm text-gray-500 print:hidden z-10">
        Right-click &rarr; Save image, or&nbsp;
        <button onClick={() => window.print()} className="text-[#722F37] font-medium underline underline-offset-2">Print</button>
      </div>

      {/* 3x3 inch card */}
      <div
        style={{
          width: '3in',
          height: '3in',
          backgroundColor: '#f5f3ed',
          borderRadius: '20px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '14px',
          overflow: 'hidden',
          position: 'relative',
        }}
        className="print:shadow-none"
      >
        {/* Character image - large, top center */}
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
          <img
            src={SOMMELIER_AVATAR}
            alt="The Somm"
            style={{
              width: '120px',
              height: '120px',
              objectFit: 'cover',
              objectPosition: 'top center',
              borderRadius: '50%',
            }}
          />
        </div>

        {/* Brand name + tagline */}
        <div style={{ textAlign: 'center', marginTop: '-4px' }}>
          <h1
            style={{
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: '30px',
              fontWeight: '700',
              color: '#722F37',
              letterSpacing: '1px',
              lineHeight: 1,
              margin: 0,
            }}
          >
            THE SOMM
          </h1>
          <p
            style={{
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: '11px',
              color: '#722F37',
              fontStyle: 'italic',
              marginTop: '4px',
            }}
          >
            Find your perfect wine in seconds
          </p>
        </div>

        {/* QR Code */}
        <QRCodeSVG
          value={chatUrl}
          size={90}
          level="H"
          fgColor="#722F37"
          bgColor="#f5f3ed"
        />

        {/* CTA */}
        <p
          style={{
            fontFamily: 'Georgia, "Times New Roman", serif',
            fontSize: '10px',
            color: '#9a7a6a',
            fontStyle: 'italic',
            margin: 0,
          }}
        >
          Scan with your phone camera
        </p>
      </div>
    </div>
  );
};

export default QRCard;
